import { createAsyncThunk } from "@reduxjs/toolkit";

import apiRequest from "../../../services/api";

// Fetch tournament list
export const fetchAllTournaments = createAsyncThunk(
  "tournaments/all",
  async (body) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    if (body.search) {
      query = query + `&search=${body.search}`;
    }
    if (body.ordering) {
      query = query + `&ordering=${body.ordering}`;
    }
    if (body.tournament_type) {
      query = query + `&tournament_type=${body.tournament_type}`;
    }
    if (body.organization_name) {
      query = query + `&organization_name=${body.organization_name}`;
    }
    if (body.roles) {
      query = query + `&roles=${body.roles}`;
    }
    if (body.status) {
      query = query + `&status=${body.status}`;
    }
    if (body.start_date) {
      query = query + `&valid_datetime=${body.start_date}`;
    }
    if (body.end_date) {
      query = query + `&expiry_datetime=${body.end_date}`;
    }
    const tournamentsListApi = await apiRequest.get(
      `v2/tournaments/?${query}`,
      {
        headers: { organization: body.userOrganization?.org_id },
      }
    );
    return tournamentsListApi.data;
  }
);

//fetch all contests
export const fetchAllContests = createAsyncThunk(
  "contests/All",
  async (body) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    if (body.search) {
      query = query + `&search=${body.search}`;
    }
    if (body.ordering) {
      query = query + `&ordering=${body.ordering}`;
    }
    if (body.tournament_type) {
      query = query + `&tournament_type=${body.tournament_type}`;
    }
    if (body.organization_name) {
      query = query + `&organization_name=${body.organization_name}`;
    }
    if (body.roles) {
      query = query + `&roles=${body.roles}`;
    }
    if (body.status) {
      query = query + `&status=${body.status}`;
    }
    if (body.start_date) {
      query = query + `&valid_datetime=${body.start_date}`;
    }
    if (body.end_date) {
      query = query + `&expiry_datetime=${body.end_date}`;
    }
    if (body.tournament_name) {
      query = query + `&tournament_name=${body.tournament_name}`;
    }
    if (body.assignment_type) {
      query = query + `&assignment_type=${body.assignment_type}`;
    }
    if (body.clinic) {
      query = query + `&clinic_name=${body.clinic}`;
    }
    if (body.user_group) {
      query = query + `&group_title=${body.user_group}`;
    }
    const contestListApi = await apiRequest.get(`v1/contests/?${query}`, {
      headers: { organization: body.userOrganization?.org_id },
    });
    return contestListApi.data;
  }
);

// Fetch tournament detail
export const fetchTournamentDetails = createAsyncThunk(
  "tournaments/details",
  async (body) => {
    const tournamentDetails = await apiRequest.get(
      `v2/tournaments/${body.tournamentId}/`,
      {
        headers: { organization: body.userOrganization?.org_id },
      }
    );
    return tournamentDetails.data;
  }
);

export const checkContestDuplicate = createAsyncThunk(
  "tournaments/check_duplicate",
  async (body) => {
    const duplicateCheck = await apiRequest.get(
      `v3/contests/duplicate/check?start_date=${body.start_date}&end_date=${body.end_date}&assignment_type=${body.assignment_type}&tournament_id=${body.tournament_id}`,
      {
        headers: { organization: body.organization_id },
      }
    );
    return duplicateCheck.data;
  }
);

// Fetch tournament contests
export const fetchTournamentContests = createAsyncThunk(
  "tournaments/contests",
  async (body) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    const tournamentContests = await apiRequest.get(
      `v2/tournaments/${body.tournamentId}/contests/?${query}`,
      {
        headers: { organization: body.userOrganization?.org_id },
      }
    );
    return tournamentContests.data;
  }
);

// Create Tournament
export const createTournament = createAsyncThunk(
  "tournaments/create",
  async (body, { rejectWithValue }) => {
    try {
      const newTournament = await apiRequest.post(`v2/tournaments/`, body, {
        headers: {
          organization: body.organization_id,
          "content-type": "application/json",
        },
      });
      return newTournament;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Update Tournament
export const updateTournament = createAsyncThunk(
  "tournaments/update",
  async (body, { rejectWithValue }) => {
    try {
      const updatedTournament = await apiRequest.put(
        `v2/tournaments/${body.tournament_id}/`,
        body,
        {
          headers: {
            organization: body.organization?.org_id,
            "content-type": "application/json",
          },
        }
      );
      return updatedTournament;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Tournament duplicate
export const duplicateTournament = createAsyncThunk(
  "tournaments/duplicate",
  async (body, { rejectWithValue }) => {
    try {
      const newTournament = await apiRequest.post(
        `v2/tournaments/${body.tournamentId}/duplicate/`,
        body.newDuplicateData,
        {
          headers: {
            organization: body.organization?.org_id,
            "content-type": "application/json",
          },
        }
      );
      return newTournament;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Tournament delete
export const deleteTournament = createAsyncThunk(
  "tournaments/delete",
  async (body, { rejectWithValue }) => {
    try {
      const tournamentDelete = await apiRequest.delete(
        `v2/tournaments/${body.tournamentId}/`,
        {
          headers: { organization: body.organization.org_id },
        }
      );
      return tournamentDelete.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Create Tournament Contest
export const createTournamentContest = createAsyncThunk(
  "tournaments/create_contest",
  async (body, { rejectWithValue }) => {
    try {
      const newTournament = await apiRequest.post(
        `v2/tournaments/${body.tournamentId}/contests/`,
        body.newContestData,
        {
          headers: {
            organization: body.newContestData.organization?.org_id,
            "content-type": "application/json",
          },
        }
      );
      return newTournament;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Get Tournament Contest
export const getTournamentContestDetail = createAsyncThunk(
  "tournaments/create_contest",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(
        `v3/tournaments/${body.tournamentId}/contests/${body.contestId}/`,
        {
          headers: {
            organization: body.userOrganization?.org_id,
            "content-type": "application/json",
          },
        }
      );
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Update Tournament Contest
export const updateTournamentContest = createAsyncThunk(
  "tournaments/create_contest",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiRequest.put(
        `v2/tournaments/${body.tournamentId}/contests/${body.contestId}/`,
        body.contestData,
        {
          headers: {
            organization: body.contestData.organization?.org_id,
            "content-type": "application/json",
          },
        }
      );
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Question fetch api
export const fetchAllUnassignedClassicalQuestions = createAsyncThunk(
  "tournament/fetch_all_unassigned_questions",
  async (body) => {
    let query = `question_use=unassigned&page=${body.page ? body.page : 1}&`;
    if (body.page_size) {
      query = query + `page_size=${body.page_size}&`;
    }
    if (body.type) {
      query = query + `type=${body.type}&`;
    }
    if (body.module) {
      query = query + `module_type=${body.module}&`;
    }
    if (body.roles) {
      query = query + `role=${body.roles}&`;
    }
    if (body.category) {
      query = query + `category=${body.category}&`;
    }
    if (body.learningPoint) {
      query = query + `learning_point=${body.learningPoint}&`;
    }
    if (body.search) {
      query = query + `search=${body.search}`;
    }
    const allRecQuestionsData = await apiRequest.get(`v1/questions/?${query}`, {
      headers: { organization: body.userOrganization?.org_id },
    });
    return allRecQuestionsData.data;
  }
);
export const fetchAllClassicalQuestions = createAsyncThunk(
  "tournament/fetch_all_questions",
  async (body) => {
    let query = `page=${body.page ? body.page : 1}&`;
    if (body.page_size) {
      query = query + `page_size=${body.page_size}&`;
    }
    if (body.type) {
      query = query + `type=${body.type}&`;
    }
    if (body.modules) {
      query = query + `module_type=${body.modules}&`;
    }
    if (body.roles) {
      query = query + `role=${body.roles}&`;
    }
    if (body.category) {
      query = query + `category=${body.category}&`;
    }
    if (body.learningPoint) {
      query = query + `learning_point=${body.learningPoint}&`;
    }
    if (
      body.lastAssignedDate &&
      "from" in body.lastAssignedDate &&
      "to" in body.lastAssignedDate
    ) {
      query =
        query +
        `last_assigned_date_after=${body.lastAssignedDate.from}&last_assigned_date_before=${body.lastAssignedDate.to}&`;
    }
    if (body.search) {
      query = query + `search=${body.search}`;
    }
    const allQuestionsData = await apiRequest.get(`v1/questions/?${query}`, {
      headers: { organization: body.userOrganization?.org_id },
    });
    return allQuestionsData.data;
  }
);

export const fetchAllClassicalLastQuestions = createAsyncThunk(
  "tournament/fetch_all_last_questions",
  async (body) => {
    let query = `question_use=last_assigned&page=${body.page ? body.page : 1}&`;
    if (body.page_size) {
      query = query + `page_size=${body.page_size}&`;
    }
    if (body.type) {
      query = query + `type=${body.type}&`;
    }
    if (body.modules) {
      query = query + `module_type=${body.modules}&`;
    }
    if (body.roles) {
      query = query + `role=${body.roles}&`;
    }
    if (body.category) {
      query = query + `category=${body.category}&`;
    }
    if (body.learningPoint) {
      query = query + `learning_point=${body.learningPoint}&`;
    }
    if (
      body.lastAssignedDate &&
      "from" in body.lastAssignedDate &&
      "to" in body.lastAssignedDate
    ) {
      query =
        query +
        `last_assigned_date_after=${body.lastAssignedDate.from}&last_assigned_date_before=${body.lastAssignedDate.to}&`;
    }
    if (body.search) {
      query = query + `search=${body.search}`;
    }
    const allQuestionsData = await apiRequest.get(`v1/questions/?${query}`, {
      headers: { organization: body.userOrganization?.org_id },
    });
    return allQuestionsData.data;
  }
);

export const fetchQuestionPoolStats = createAsyncThunk(
  "tournament/fetch_question_pool_stats",
  async (body) => {
    let query = `roles=${body.roles}`;
    if (body.learningPoints) {
      query = query + `&learning_points=${body.learningPoints}`;
    }
    if (body.tags) {
      query = query + `&tags=${body.tags}`;
    }
    if (body.exclude) {
      query = query + `&exclude=${body.exclude}`;
    }
    if (body.version_compatibilities) {
      query =
        query + `&version_compatibilities=${body.version_compatibilities}`;
    }
    const questionPoolStats = await apiRequest.get(
      `v2/learning-points-tags/?${query}`,
      {
        headers: { organization: body.userOrganization?.org_id },
      }
    );
    return { ...questionPoolStats.data, type: body.type };
  }
);

export const publishAutomatedContest = createAsyncThunk(
  "tournament/publish_automated_contest",
  async (body) => {
    const deployContest = await apiRequest.post(
      `v2/tournament/${body.tournamentId}/publish/`,
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return deployContest;
  }
);

export const fetchAutomatedTailoredContentLearningPoints = createAsyncThunk(
  "tournament/fetch_automated_tailored_content_learning_points",
  async (body) => {
    let query = "";
    if (body.threshold) {
      query = query + `threshold=${body.threshold}&`;
    }
    if (body.assignment_type) {
      query = query + `assignment_type=${body.assignment_type}&`;
    }
    if (body.organization) {
      query = query + `organization=${body.organization}&`;
    }
    if (body.group) {
      query = query + `group=${body.group}&`;
    }
    if (body.clinic) {
      query = query + `clinic=${body.clinic}&`;
    }
    query = query + `page_size=200`; // Caution: Temporary Fix being applied here this change is being made after discussion with the team lead and looking at the design contraints a change will be applied soon here after this release.
    const automatedTailoredContentLearningPoints = await apiRequest.get(
      `v2/tailored_education/learning_points/eligible/?${query}`,
      {
        headers: { organization: body.userOrganization?.org_id },
      }
    );
    return automatedTailoredContentLearningPoints.data;
  }
);

export const createLearningPointPointTailoredContent = createAsyncThunk(
  "tournament/create_learning_point_point_tailored_content",
  async (body, { rejectWithValue }) => {
    try {
      const automatedTailoredContentLearningPoints = await apiRequest.post(
        `v2/tailored_education/assignments/`,
        body,
        {
          headers: { organization: body.userOrganization?.org_id },
        }
      );

      return automatedTailoredContentLearningPoints.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || "Failed to create tailored content"
      );
    }
  }
);

export const fetchCustomAssignments = createAsyncThunk(
  "tournament/fetch_custom_assignments",
  async (body) => {
    const params = new URLSearchParams();

    if (body.page) params.append("page", body.page);
    if (body.page_size) params.append("page_size", body.page_size);
    if (body.ordering) params.append("ordering", body.ordering);
    if (body.status) params.append("status", body.status.toLowerCase());
    if (body.start_date) params.append("start_date", body.start_date);
    if (body.end_date) params.append("end_date", body.end_date);

    const customAssignments = await apiRequest.get(
      `v2/tailored_education/assignments?${params.toString()}`,
      {
        headers: { organization: body.userOrganization?.org_id },
      }
    );

    return customAssignments.data;
  }
);

export const fetchCustomAssignmentDetails = createAsyncThunk(
  "tournament/fetch_custom_assignment_details",
  async (body) => {
    const customAssignmentDetails = await apiRequest.get(
      `v2/tailored_education/assignments/${body.contentId}/`,
      {
        headers: { organization: body.userOrganization?.org_id },
      }
    );
    return customAssignmentDetails.data;
  }
);

export const fetchEligibleUsersForCusttomAssignments = createAsyncThunk(
  "tournament/fetch_eligible_users_for_custom_assignments",
  async (body) => {
    let query = `page=${body.page ? body.page : 1}&`;
    if (body.page_size) {
      query = query + `page_size=${body.page_size}&`;
    }
    if (body.ordering) {
      query = query + `ordering=${body.ordering}&`;
    }
    if (body.group) {
      query = query + `group=${body.group}&`;
    }
    if (body.clinic) {
      query = query + `clinic=${body.clinic}&`;
    }
    const eligibleUsers = await apiRequest.get(
      `v2/tailored_education/assignments/${body.contentId}/eligible_users/?${query}`,
      {
        headers: { organization: body.userOrganization?.org_id },
      }
    );
    return eligibleUsers.data;
  }
);

export const fetchNonEligibleUsersForCusttomAssignments = createAsyncThunk(
  "tournament/fetch_un_eligible_users_for_custom_assignments",
  async (body) => {
    let query = `page=${body.page ? body.page : 1}&`;
    if (body.page_size) {
      query = query + `page_size=${body.page_size}&`;
    }
    if (body.ordering) {
      query = query + `ordering=${body.ordering}&`;
    }
    if (body.group) {
      query = query + `group=${body.group}&`;
    }
    if (body.clinic) {
      query = query + `clinic=${body.clinic}&`;
    }
    const unEligibleUsers = await apiRequest.get(
      `v2/tailored_education/assignments/${body.contentId}/non_eligible_users/?${query}`,
      {
        headers: { organization: body.userOrganization?.org_id },
      }
    );
    return unEligibleUsers.data;
  }
);

export const fetchCustomAssignmentQuestions = createAsyncThunk(
  "tournament/fetch_custom_assignment_questions",
  async (body) => {
    let query = `page=${body.page ? body.page : 1}&`;
    if (body.page_size) {
      query = query + `page_size=${body.page_size}&`;
    }
    if (body.ordering) {
      query = query + `ordering=${body.ordering}&`;
    }
    if (body.assignment__uuid) {
      query = query + `assignment__uuid=${body.assignment__uuid}&`;
    }
    if (body.user__user_id) {
      query = query + `user__user_id=${body.user__user_id}&`;
    }
    const customAssignmentQuestions = await apiRequest.get(
      `/v2/tailored_education/contents/questions?${query}`,
      {
        headers: { organization: body.userOrganization?.org_id },
      }
    );
    return customAssignmentQuestions.data;
  }
);
